import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { urlPath } from '@/utils/lpPath'

const Policy: React.FC = () => {
  return (
    <>
      <Head>
        <title>サイトポリシー | アット葬儀（@葬儀）</title>
      </Head>
      <main>
        <div className="contact">
          <div id="contactNavbarPC" className="flex justify-between sp:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="120"
                  height="55"
                />
              </a>
            </Link>
          </div>
          <div id="contactNavbarSP" className="flex justify-between pc:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="105"
                  height="48"
                />
              </a>
            </Link>
          </div>
          <div className="body">
            <div className="faqCaption mb-16 text-center">
              <h1 className="caption">サイトポリシー</h1>
            </div>
            <div className="section">
              <p className="mb-8">
                @葬儀（アット葬儀）のウェブサイト（以下「当サイト」といいます）は、多くの方に快適にご利用いただくために、ユーザビリティに配慮した制作を行っています。このページでは、ユーザビリティに配慮した機能や推奨する閲覧環境についてご説明します。
              </p>
              <section className="mt-8">
                <p className="mb-8 text-lg font-bold">免責事項</p>
                <p>
                  本サイトの利用は、お客様の責任で行われるものとします。
                  <br />
                  本サイトに掲載する文書・写真・イラスト・動画・音声・ソフトウェア・リンク等の情報については、慎重に管理しております。しかし、本サイトにおける情報の正確性および完全性を保証するものではありませんので、あらかじめご了承ください。
                  <br />
                  また、当社は、本サイトに掲載する情報の全部または一部をお客様へ事前の告知なしに変更する場合がありますが、本サイトを更新することを必ずお約束するものではありません。
                  <br />
                  当社は、お客様が本サイトから入手されたあらゆる情報（データ類及びリック設定による他のサイトからのあらゆる情報を含む）により発生したいかなる損害についても、一切の責任を負いません。
                  <br />
                  通信環境、あるいはお客様のソフトウェア及びハードウェア環境の理由により、本サイトが正常にご利用できない場合があります。
                  <br />
                  また、当社は、お客様へ事前の告知なしに本サイト及び本ウェブサイトに掲示したコンテンツをまたはURLを予告なく変更・追加・削除することがあります。また、本ウェブサイトの運営を一時停止または中止することがあります。
                </p>
              </section>
              <section className="mt-8">
                <p className="mb-8 text-lg font-bold">著作権</p>
                <p>
                  本サイトの文書・写真・イラスト・動画・音声・デザイン・ソースコード、データ類等は、グループ企業および第三者が有する著作権、特許権、商標権その他の権利により保護されております。本サイトの文書・写真・イラスト・動画・デザイン・ソースコード、データ類等については、第三者が閲覧可能な環境に流用されない、非営利の私的な個人的利用に限って、表示、複製、印刷等をすることができます。ただし、一切の改変については認められません。また、著作権等に関するあらゆる表示を削除することはできません。当社は、第三者の著作権、特許権、商標権その他いかなる権利も許諾するものではありません。
                </p>
              </section>
              <section className="mt-8">
                <p className="mb-8 text-lg font-bold">閲覧環境</p>
                <table className="w-full text-left table-auto">
                  <tbody className="align-baseline text-primary">
                    <tr>
                      <td className="p-2 whitespace-no-wrap">Windows</td>
                      <td className="p-2">
                        Google Chrome 最新版、Mozilla Firefox 最新版、Microsoft Edge 最新版
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2 whitespace-no-wrap">Macintosh</td>
                      <td className="p-2">
                        Google Chrome 最新版、Mozilla Firefox 最新版、Safari 最新版
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2 whitespace-no-wrap">iPhone</td>
                      <td className="p-2">Google Chrome 最新版、Safari 最新版</td>
                    </tr>
                    <tr>
                      <td className="p-2 whitespace-no-wrap">Android</td>
                      <td className="p-2">Google Chrome 最新版</td>
                    </tr>
                  </tbody>
                </table>
              </section>
              <section className="mt-8">
                <p className="mb-8 text-lg font-bold">使用技術</p>
                <p>
                  当サイトではお客さまにより便利にサイトを利用していただけるよう、JavaScriptを使用しております。
                  <br />
                  JavaScriptを無効にして使用されている場合には、ページが予期せぬ表示をする場合があります。当サイトご利用の際には、JavaScriptを有効にすることを推奨します。
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
export default Policy
